module.exports = __webpack_public_path__ + "img/residuos_alimentos.db874391.png";